import CountryLocalization from '../types/localization/countryLocalization';
import type Localization from '../helpers/i18n/localization';
import { isProduction } from '../helpers/env/checkEnvironmentType';
import { INDEX_ENVIRONMENT_PREFIX } from '../constants/typesense';

const getTypesenseIndexName = (languageAndCountry: string, localizationDefinitions: Localization): Maybe<string> => {

  const environmentPrefix = isProduction() ? INDEX_ENVIRONMENT_PREFIX.PRODUCTION : INDEX_ENVIRONMENT_PREFIX.STAGE;
  const countryLocalization = localizationDefinitions.getByLanguageAndCountry(languageAndCountry);

  if (!countryLocalization) {

    return null;

  }

  return `${environmentPrefix}${CountryLocalization.TYPESENSE_INDEX_NAME_SEPARATOR}${languageAndCountry}`;

};

export { getTypesenseIndexName };
